<template lang="html">
  <div class="container">

    <div class="header">
      <i class="icon-fanhui iconfont back" @click="back"></i>
      <h2>两化融合</h2>
    </div>
    <!-- 中间内容 -->
    <div class="knowcontent">
      <div class="knowbox" v-if="type == 1">
      <div class="box">
        <ul>
          <li  v-for="(item,index) in types" :class="{'yes': currentType == index}" @click="changeType(index)">{{item}}</li>
        </ul>
        <div class="txp">
        <div v-if="data.length>0" @click="fn(item.id)" v-for="item in data" :key="item.id" class="list-box">
          <p class="lists">{{item.title}} <span class="show-new" v-if="!item.news_id&&item.created_at.slice(0,4)!=2017">New</span></p>
          <p class="list-time"> <img src="../assets/img/fbtime.png"/> &nbsp;{{item.created_at?item.created_at.slice(0,10):''}}</p>
          <p class="list-author">
           <span style="float:left"><img src="../assets/img/author.png"/> {{item.name}}</span>
           <span style='float:right'>
             <span style="display:inline-block;width:1.5rem;text-align:center"><img src="../assets/img/count.png"/>{{item.count}}</span>
             <span style="display:inline-block;width:1.2rem;text-align:center"><img src="../assets/img/点赞.png"/>{{item.laud}}</span>
           </span>
          </p>
        </div>
        <nodata v-if="data.length<=0"></nodata>
      </div>
      </div>
    </div>
    <div class="knowmore" v-if="type == 2">
      <h2>{{detailData.title}}</h2>

      <p class="top">
        <span>
          <i class="icon-sanjiaoxiabiao iconfont col" :class="{'isclick':news_check.to_laud == 1}" @click="changeState(1)"></i>
          赞同
        </span>
        <span>
          <i class="icon-sanjiaoxiabiao iconfont col nouse" :class="{'isclick':news_check.to_disuse == 1}"  @click="changeState(2)"></i>
          无用
        </span>
        <span>
          <i class="iconfont star" :class="{'icon-wodeshoucang':news_check.to_collect == 1,'icon-meishoucang':news_check.to_collect == 0}" @click="changeState(3)"></i>
          <!-- <img src="../assets/img/shoucang_icon.png" alt="" style="width:16px;margin-right: 0.25rem" v-if="news_check.to_collect == 0"  @click="changeState(3)"> -->
          收藏
        </span>
      </p>
      <div class="more">
        <p v-html="detailData.content"></p>
        <span class="time">
          {{detailData.created_at?detailData.created_at.slice(0,10):''}}
        </span>
      </div>
    </div >
    </div>
    <!-- 中间内容 -->

  </div>
</template>


<script>
 import nodata from './public/nodata'
  export default {
    components:{
      nodata
    },
    data () {
      return {
        type: 1,
        currentType: 0,
        types: [],
        data: [],
        detailData: {},
        news_check: {},
        currentYear: '',//当前年份
      }
    },
    methods: {
      fn (id) {
        this.type = 2
        this.$http.getDetailKnow(id).then(res => {
          this.detailData = res.data[0]
          if (this.detailData.news_check == null) {
            this.news_check = {
              to_laud: 0,
              to_collect: 0,
              to_disuse: 0,
            }
          } else {
            this.news_check = this.detailData.news_check
          }
        }, (err) => {
          this.$notice.tip('获取数据失败')
        })
      },
      changeType (index) {
        this.currentType = index
        this.$http.getKnowledgeList(index,'fusion').then(res => {
          this.data = res.data.news

        })
      },
      changeState (type) {
        if (type == 1) {
          this.news_check.to_laud = this.news_check.to_laud == 0 ? 1 : 0
          if (this.news_check.to_laud == 1) {
            this.news_check.to_disuse = 0
          }
        } else if (type == 2) {
          this.news_check.to_disuse = this.news_check.to_disuse == 0 ? 1 : 0
          if (this.news_check.to_disuse == 1) {
            this.news_check.to_laud = 0
          }
        } else {
          this.news_check.to_collect = this.news_check.to_collect == 0 ? 1 : 0
        }

        this.$http.updataKnowState({ id: this.detailData.id, to_laud: this.news_check.to_laud, to_collect: this.news_check.to_collect, to_disuse: this.news_check.to_disuse }).then(res => {
        })
      },
      back () {
        if (this.type == 1) {
          this.$router.push({ name: 'my' })
        } else {
          this.type = 1
        }
      },
    },
    created () {
      this.currentYear = (new Date).getFullYear()
      this.$http.getKnowledgeList(0,'fusion').then(res => {
         if (res.errCode == 0) {
            let obj = res.data.types
            let types = {}
            for (var key in obj) {
            types[key] = obj[key]
            }
            types[0] = '全部'
            this.types = types
            this.data = res.data.news
        }
      })
    },
  }

</script>

<style lang="css" scoped>
  * {
    -webkit-overflow-scrolling: touch;
  }
  p {
    word-break: break-all;
  }
  .container {
    color: #333;
    width: 100vw;
    /* height: 100vh; */
    height: 100%;
    overflow: hidden;
    font-family: PingFangSC-Regular;
  }
  .header {
    width: 100%;
    color: #000;
    text-align: center;
    font-size: 0.375rem;
    background-color: #fff;
    height: 7%;
    position: relative;
  }
  .header h2 {
    color: #333;
    font-size: 0.4375rem;
    border-bottom: 1px solid #ddd;
    height: 100%;
    padding-top: 3.5%;
  }
  .knowmore {
    width: 100%;
    background: #fff;
    margin-top: 0.21875rem;
    /* height: 100%; */
    /* height: 17rem;
          overflow: scroll */
  }
  .knowmore h2 {
    text-align: center;
    font-size: 15px;
    padding-top: 0.40625rem;
    padding-bottom: 0.84375rem;
    font-weight: 600;
  }
  .top {
    width: 95%;
    position: relative;
    margin: auto;
    line-height: 16px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 0.5rem;
  }
  .top span {
    display: inline-block;
    color: #666;
    font-size: 0.375rem;
    display: inline-flex;
    align-items: center;
    line-height: 16px;
  }
  .top span:first-child {
    margin-right: 0.3125rem;
  }

  .top span:last-child {
    position: absolute;
    right: 0%;
    top: 0;
    display: inline-flex;
    align-items: baseline;
    height: 16px;
  }
  .more {
    width: 95%;
    height: 70%;
    overflow-y: scroll;
    margin: auto;
    font-size: 0.4375rem;
    font-family: PingFangSC-Regular;
    text-align: justify;
    padding-top: 0.3125rem;
  }
  .more p img {
    text-align: center;
  }
  .time {
    text-align: right;
    display: block;
    margin-right: 3%;
    margin-bottom: 5%;
  }
  .knowcontent {
    height: 17rem;
    margin-bottom: 3rem;
    overflow: scroll;
  }
  .knowbox {
    width: 100%;
    height: 93%;
    background: #fff;
  }

  .txp {
    width: 100%;
    padding: 0.2rem;
    background: #fff;
  }
  .box {
    width: 100%;
    height: auto;
    padding-bottom: 0.5rem;
  }
  .box ul {
    white-space: nowrap;
    overflow-x: scroll;
    width: 100%;
    height: auto;
  }
  .box ul li {
    display: inline-block;
    min-width: 1.6rem;
    height: 1.2rem;
    line-height: 1.2rem;
    padding: 0 0.4rem;
    font-size: 0.3375rem;
    text-align: center;
  }
  .list-box {
    padding: 0 0.1rem;
    min-height: 1.25rem;
    font-size: 0.4375rem;
    margin-top: 0.2rem;
    border-bottom: 1px solid #d8d8d8;
  }
  .list-box img {
    width: 0.4rem;
    vertical-align: bottom;
  }
  .list-time {
    padding-bottom: 0.2rem;
    font-size: 0.3rem;
    color: #666;
  }
  .list-time img {
    width: 0.3rem;
    vertical-align: middle;
  }
  .list-author {
    padding-bottom: 0.2rem;
    font-size: 0.3rem;
    color: #666;
    overflow: hidden;
  }
  .list-author span {
    /* float: left; */
    /* margin-left: 2rem; */
  }
  .yes {
    border-bottom: 0.0625rem solid #5483d2;
  }
  .back {
    /*transform: rotate(90deg);*/
    display: inline-block;
    position: absolute;
    left: 0.3125rem;
    top: 18%;
    font-weight: bold;
    height: 0.78125rem;
    line-height: 0.78125rem;
    color: #86898e;
  }
  .go {
    transform: rotate(-180deg);
    display: inline-block;
    position: absolute;
    right: 0.34375rem;
    top: 20%;
    font-weight: bold;
    font-size: 0.375rem;
    height: 0.78125rem;
    line-height: 0.78125rem;
    color: #86898e;
  }
  input {
    width: 96%;
    height: 100%;
    border-radius: 100px;
    text-align: center;
    border: 1px solid #ddd;
    margin: auto;
    display: block;
    background-color: #fff;
  }
  .inp {
    background: #fafafa;
    padding-top: 0.15625rem;
    padding-bottom: 5px;
    /*height: 7%;*/
    height: 1.0625rem;
  }
  .col {
    color: #666666;
    display: inline-block;
    font-size: 20px;
    line-height: 0.375rem;
    /*margin-right: 0.1875rem;*/
  }
  .nouse {
    transform: rotate(-180deg);
  }
  .isclick {
    color: #5483d2;
  }
  .star {
    margin-right: 0.25rem;
  }
  .icon-wodeshoucang.star {
    color: #f2d900;
  }
  .lists {
    line-height: 1rem;
    width: 100%;
    height: auto;
  }
  .show-new {
    font-size: 10px;
    background: #ff3333;
    border-radius: 6px;
    padding: 0 2px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Fusion.vue